import styled from '@emotion/styled';
import { useUser } from '@libs/contexts';
import { colors } from '@libs/ui';
import { Divider, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { CompanyButton, CompanyMenu, Logo, UserButton, UserMenu } from './components';

const GlobalAreaContainer = styled.div`
  display: grid;
  grid-template-rows: 40px;
  grid-template-columns: 200px repeat(5, 1fr);
  justify-content: space-between;
  color: #000d0b;
  margin: 0px;
  padding-left: 12px;
  padding-right: 12px;
  height: 40px;
  overflow: hidden;
  z-index: 1201;
  background-color: ${colors.gray};
  position: sticky;
  top:0;
`;

export interface GlobalAreaProps {
  /**
   * サブシステム内にいない場合に、会社切替のところに現在の会社領域ではなく、`会社を選択`を表示させる
   * @default true
   */
  isUnderSubsystem?: boolean;
  homePath?: string;
  children?: ReactNode;
}

export function GlobalArea(props: GlobalAreaProps) {
  const { user } = useUser();
  const [companyMenuAnchorEl, setCompanyMenuAnchorEl] = useState<HTMLElement | null>(null);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <GlobalAreaContainer id="global-area">
      <Logo homePath={props.homePath} />
      {props.children}
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={1}
        alignItems="center"
        sx={{ gridColumn: '6/6' }}
        divider={<Divider orientation="vertical" sx={{ borderColor: '#B0B0B0', height: '60%' }} />}
      >
        {user ? (
          <>
            <CompanyButton
              anchorEl={companyMenuAnchorEl}
              setAnchorEl={setCompanyMenuAnchorEl}
              user={user}
              isUnderSubsystem={props.isUnderSubsystem ?? true}
            />
            <UserButton user={user} anchorEl={userMenuAnchorEl} setAnchorEl={setUserMenuAnchorEl} />
          </>
        ) : null}
      </Stack>
      {user ? (
        <>
          <CompanyMenu user={user} anchorEl={companyMenuAnchorEl} setAnchorEl={setCompanyMenuAnchorEl} />
          <UserMenu user={user} anchorEl={userMenuAnchorEl} setAnchorEl={setUserMenuAnchorEl} />
        </>
      ) : null}
    </GlobalAreaContainer>
  );
}
